import React, { useContext } from 'react';
import { Button } from 'antd';
import { useDispatch } from 'react-redux';
import ConfirmationModal from '../../../main/components/ConfirmationModal';
import { NOTIFICATION_TYPES } from '../../../main/utils/const';
import GlobalContext from '../../../main/utils/GlobalContext';

export const SingleSignupListItem = ({ signup, onDelete, roleLabels }) => {
  const { locales } = useContext(GlobalContext);
  const {
    notification: { addNotification },
  } = useDispatch();

  const renderLinkInformation = () => {
    if (signup.used) {
      return `${locales.admin.usedBy} ${signup.userFirstName} ${signup.userSurname}`;
    }
    if (new Date(signup.expireAt) > new Date()) {
      return `${locales.admin.expiresIn} ${Math.floor(
        (new Date(signup.expireAt) - new Date()) / (1000 * 60 * 60 * 24),
      )} ${locales.admin.daysAnd} ${Math.floor(
        new Date(signup.expireAt).getHours(),
      )} ${locales.admin.hours}`;
    }
    return locales.admin.expired;
  };

  const expired = (datetime) => {
    return new Date(datetime) < new Date();
  };

  const onCopyLinkClick = (link) => {
    window.navigator.clipboard.writeText(
      `${window.location.origin}/elevated_privilege_signup/${link.uuid}`,
    );
    addNotification({
      text: locales.admin.linkCopiedToClipboard,
      type: NOTIFICATION_TYPES.success,
    });
  };

  const getStatusText = () => {
    if (signup.used) {
      return locales.admin.used;
    }
    if (expired(signup.expireAt)) {
      return locales.admin.expired;
    }
    return locales.admin.unused;
  };

  return (
    <>
      <tr>
        <td>{getStatusText()}</td>
        <td>{roleLabels.find((r) => r.value === signup.role)?.label}</td>
        <td>{renderLinkInformation()}</td>
        <td>
          <div>
            <Button
              type="link"
              onClick={() => {
                onCopyLinkClick(signup);
              }}
              disabled={signup.used || expired(signup.expireAt)}
            >
              {locales.admin.copyLink}
            </Button>
          </div>
        </td>
        <td>
          <ConfirmationModal
            body={locales.admin.areYouSure}
            confirmText={locales.admin.delete}
            onConfirm={() => onDelete(signup.id)}
          >
            <Button disabled={signup.used} type="link" danger ghost>
              {locales.admin.delete}
            </Button>
          </ConfirmationModal>
        </td>
      </tr>
    </>
  );
};
